import React from 'react';
import { addFilter } from '../../common/services/navigation';
import SearchInput from '../../common/components/_SearchBox';
import DropdownItem from '../../common/components/_DropdownItem';
import DateFilterDropdown from '../../common/components/_DateFilterDropdown';

function Filter({ search, filters, settings }) {
	const change = e => {
		addFilter(search, filters, e.target.id, e.target.checked);
	};

	const isChecked = (key) => {
		let value = search[filters];
		return !!(value && value.indexOf(key) >= 0);
	};
	return (
        <div className="filter-bar our-stories-filter">
            <div className="filter__text">
                Filter by
            </div>
            <SearchInput search={search} settings={settings}/>
            {filters && filters.taxonomyFilters && <DropdownItem search={search} title='Industries' options={filters.taxonomyFilters.industry} name='industry' istaxonomy={true} />}
            <DateFilterDropdown search={search} isYear={true} settings={settings} />
        </div>
	);
}

export default Filter;
